export default __webpack_public_path__ + "static/media/gatsby.1b98ef4d.png";